export default __webpack_public_path__ + "4d422838ba196a70652156605f3f340b.jpg";